import { useState, useEffect } from "react";
import axios from "axios";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Typography,
  TablePagination,
} from "@mui/material";
import { API_ENDPOINT } from "../../../services/api/resources";
import SearchBar from "../../../components/common/SearchBar/SearchBar";

const InvoiceTable = ({ VendorToken }) => {
  const [data, setData] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);

  const ROWS_PER_PAGE = 10;

  const handleViewItems = (invoice) => {
    setSelectedInvoice(invoice);
    setOpenModal(true);
  };

  console.log(VendorToken);
  useEffect(() => {
    if (!VendorToken) return;

    const fetchInvoices = async () => {
      try {
        const res = await axios.post(API_ENDPOINT.get_vendor_invoices, {
          vendor_token: VendorToken,
        });

        setData(res?.data?.invoices || []);
      } catch (err) {
        console.error("Error fetching invoices", err);
      }
    };

    fetchInvoices();
  }, [VendorToken]);

  console.log(data);

  const filteredData = data.filter(
    (row) =>
      row.invoice_number?.toLowerCase().includes(search.toLowerCase()) ||
      row.pi_po_number?.toLowerCase().includes(search.toLowerCase())
  );

  const paginatedData = filteredData.slice(
    (page - 1) * ROWS_PER_PAGE,
    page * ROWS_PER_PAGE
  );

  //chat
  useEffect(() => {
    const chatActionRaw = sessionStorage.getItem("CHAT_ACTION");
    if (!chatActionRaw) return;

    const { action, invoice_process_code } = JSON.parse(chatActionRaw);

    // consume once
    sessionStorage.removeItem("CHAT_ACTION");

    if (action === "search_invoices") {
      if (!paginatedData.length) {
        sessionStorage.setItem(
          "CHAT_ACTION",
          JSON.stringify({ action, invoice_process_code })
        );
        setSearch(invoice_process_code);
        return;
      }
    }

    if (action === "open_specific_invoice") {
      if (!paginatedData.length) {
        sessionStorage.setItem(
          "CHAT_ACTION",
          JSON.stringify({ action, invoice_process_code })
        );
        handleViewItems(invoice_process_code);
        return;
      }
    }
  }, [paginatedData]);

  return (
    <>
      {/* MAIN INVOICE TABLE */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 2,
          mb: 2,
        }}
      >
        <Box sx={{ width: 300 }}>
          <SearchBar
            value={search}
            onChange={(value) => {
              setSearch(value);
              setPage(1); // ✅ reset page on search
            }}
          />
        </Box>

        {/* <Typography sx={{ fontSize: 14, fontWeight: 600 }}>
          Total Invoices: {filteredData.length}
        </Typography> */}
      </Box>

      <TableContainer
        component={Paper}
        sx={{
          borderRadius: 2,
          boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
          mt: 3,
        }}
      >
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              {[
                "ID",
                "PO No",
                "Invoice No",
                "Invoice Date",
                "Amount",

                "Created At",
                "Action",
              ].map((header) => (
                <TableCell
                  key={header}
                  sx={{
                    fontWeight: 600,
                    backgroundColor: "#e0e9ee",
                    fontSize: "14px",
                  }}
                >
                  {header}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {paginatedData.map((row, idx) => (
              <TableRow
                key={idx}
                sx={{
                  "&:hover": { backgroundColor: "#f5f5f5" },
                  borderBottom: "1px solid #e2e8f0",
                }}
              >
                <TableCell sx={{ fontSize: "14px" }}>
                  {(page - 1) * ROWS_PER_PAGE + idx + 1}
                </TableCell>
                <TableCell sx={{ fontSize: "14px" }}>
                  {row.pi_po_number}
                </TableCell>
                <TableCell sx={{ fontSize: "14px" }}>
                  {row.invoice_number}
                </TableCell>
                <TableCell sx={{ fontSize: "14px" }}>
                  {row.invoice_date}
                </TableCell>
                <TableCell
                  sx={{
                    fontSize: "14px",
                    fontWeight: 600,
                    color: "#075b97",
                  }}
                >
                  ₹{Number(row.grand_total).toLocaleString("en-IN")}
                </TableCell>

                <TableCell sx={{ fontSize: "14px" }}>
                  {new Date(row.created_at).toLocaleString("en-IN", {
                    timeZone: "Asia/Kolkata",
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                    hour12: true,
                  })}
                </TableCell>
                <TableCell>
                  <Button
                    variant="outlined"
                    size="small"
                    sx={{
                      fontSize: "12px",
                      fontWeight: 600,
                      textTransform: "none",
                    }}
                    onClick={() => handleViewItems(row)}
                  >
                    View Items
                  </Button>
                </TableCell>
              </TableRow>
            ))}

            {!data.length && (
              <TableRow>
                <TableCell colSpan={8} align="center">
                  No invoices found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
        <TablePagination
          component="div"
          count={filteredData.length}
          page={page - 1}
          rowsPerPage={ROWS_PER_PAGE}
          rowsPerPageOptions={[10]}
          onPageChange={(_, newPage) => setPage(newPage + 1)}
          sx={{
            mt: 1.5,
            "& .MuiTablePagination-toolbar": {
              minHeight: 64,
              paddingLeft: 8,
              paddingRight: 8,
            },
            "& .MuiTablePagination-displayedRows": {
              fontSize: "14px",
              fontWeight: 500,
            },
            "& .MuiIconButton-root": {
              fontSize: "22px",
              padding: "10px",
            },
          }}
        />
      </TableContainer>

      {/* LINE ITEMS MODAL */}
      <Dialog
        open={openModal}
        onClose={() => setOpenModal(false)}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle sx={{ fontWeight: 600, fontSize: "14px" }}>
          Invoice Items
        </DialogTitle>

        <DialogContent>
          <TableContainer
            component={Paper}
            sx={{
              borderRadius: 2,
              boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
              fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
            }}
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  {[
                    "Sl.No",
                    "Item Code",
                    "Description",
                    "HSN",
                    "Qty",
                    "Unit Rate",
                    "Total",
                    "Tax",
                    "Taxable Amount",
                  ].map((h) => (
                    <TableCell
                      key={h}
                      sx={{
                        fontWeight: 600,
                        backgroundColor: "#e0e9ee",
                        fontSize: "14px",
                      }}
                    >
                      {h}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {selectedInvoice?.items?.map((item, idx) => (
                  <TableRow
                    key={idx}
                    sx={{ "&:hover": { backgroundColor: "#f5f5f5" } }}
                  >
                    <TableCell sx={{ fontSize: "14px" }}>{idx + 1}</TableCell>
                    <TableCell sx={{ fontSize: "14px" }}>
                      {item.item_code}
                    </TableCell>
                    <TableCell sx={{ fontSize: "14px" }}>
                      {item.description}
                    </TableCell>
                    <TableCell sx={{ fontSize: "14px" }}>
                      {item.hsn || "-"}
                    </TableCell>
                    <TableCell sx={{ fontSize: "14px" }}>
                      {item.quantity}
                    </TableCell>
                    <TableCell sx={{ fontSize: "14px" }}>
                      ₹{Number(item.unit_price).toLocaleString("en-IN")}
                    </TableCell>
                    <TableCell sx={{ fontSize: "14px" }}>
                      {/* ₹{Number(item.total_amount).toLocaleString("en-IN")} */}
                      ₹
                      {(
                        Number(item.unit_price) * Number(item.quantity)
                      ).toLocaleString("en-IN")}
                    </TableCell>
                    <TableCell sx={{ fontSize: "14px" }}>
                      {item.tax_rate || "-"}
                    </TableCell>
                    <TableCell
                      sx={{
                        fontSize: "14px",
                        fontWeight: 600,
                        color: "#075b97",
                      }}
                    >
                      ₹{Number(item.total_amount).toLocaleString("en-IN")}
                    </TableCell>
                  </TableRow>
                ))}

                {!selectedInvoice?.items?.length && (
                  <TableRow>
                    <TableCell
                      colSpan={9}
                      align="center"
                      sx={{ fontSize: "14px" }}
                    >
                      No line items found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>

        <Box
          sx={{ display: "flex", justifyContent: "flex-end", padding: "10px" }}
        >
          <Button
            variant="contained"
            onClick={() => setOpenModal(false)}
            sx={{ fontSize: "12px", fontWeight: "bold" }}
          >
            close
          </Button>
        </Box>
      </Dialog>
    </>
  );
};

export default InvoiceTable;
